import { Backend } from '../../../api/Backend';
import { LinearStreamInfo } from '../streamInfo/LinearStreamInfo';

export class LiveToReplayHandler {
  private _backend: Backend;
  private _streamInfo: LinearStreamInfo;
  private _isPaused = false;
  constructor(backend: Backend, streamInfo: LinearStreamInfo) {
    this._backend = backend;
    this._streamInfo = streamInfo;
  }

  pause() {
    this._isPaused = true;
  }

  resume() {
    if (this._isPaused) {
      this._convert();
    }
  }

  onSeek() {
    return this._convert();
  }

  onTrickPlay() {
    return this._convert();
  }

  _convert() {
    const replayInfo = this._streamInfo.convertToReplay();
    const playTimes = this._streamInfo.convertPlayTimes(
      this._backend.playerController.playerService.absolutePosition,
      this._backend.playerController.playerService.duration,
      this._backend.playerController.playerService.isLive
    );

    replayInfo.updateBookmark(playTimes.position, playTimes.duration);
    replayInfo.resumeFromLive = true;
    return this._backend.playerController.changeStream(replayInfo, true, false);
  }
}
